/**
 * Created by dx.yang on 2017/3/20.
 */


// import KsAlert from 'ksc-vue-ui2/src/services/KsAlert';
// export default new KsAlert('.view-main-container');

import Message from 'kpc/components/message';

export default {
    send(message:any, type = 'success') {
        if (type === 'success') {
            Message.success(message);
        } else {
            Message.error(message);
        }
    }
};
